module.exports = __webpack_public_path__ + "img/wechat-qr-avatar.ab168ba.png";